import { useCallback } from 'react';

import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, useQueryClient, UseMutationResult } from 'react-query';
import { ErrorMessage, TaxRate, TaxRateWrite } from 'types';
import { client } from 'utils/api-client';

export default function useCreateTaxRate(): UseMutationResult<
  AxiosResponse<TaxRate>,
  AxiosError<ErrorMessage>,
  TaxRateWrite
> {
  const queryClient = useQueryClient();

  const createTaxRate = useCallback((taxRate: TaxRateWrite): Promise<AxiosResponse<TaxRate>> => {
    return client.post('tax-rates/', taxRate);
  }, []);
  return useMutation(createTaxRate, {
    onSuccess: () => {
      queryClient.invalidateQueries('taxRates');
    },
  });
}
